// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDk6EnFxZ8RQ9PIHeAiOdGzucOIWauIYho",
    authDomain: "medassure-dd57e.firebaseapp.com",
    projectId: "medassure-dd57e",
    storageBucket: "medassure-dd57e.appspot.com",
    messagingSenderId: "94725948586",
    appId: "1:94725948586:web:81cbf52693125ff5667cd3"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

